<template>
    <form-group :validator="v" :label="label" :label-for="id" :description="tip" :messages="messages">
        <template slot-scope="{ attrs, listeners }">
          <v-select :id="id"                  
                :options="options"
                :getOptionLabel="option => option.name"
                :value="value"
                aria-label="Search for supervisor"   
                screenreader="Search for supervisor" 
                @input="onSelected"
                :data-test="slug"
                v-bind="attrs"
                :state="v.$dirty ? !v.$error : null"
                v-on="listeners"
                :filterBy="myFilterBy"
                :disabled="disabled">
            <template slot="no-options">
                Type to search employees.
            </template>
            <template #option="{name, email, pcn, classificationTitle}">
                <div class="d-center">
                    <strong>{{name}}</strong> - {{email}} <strong>(Class:</strong> {{classificationTitle}}
                    <span v-if="showPcn">
                        <strong>, PCN:</strong> {{pcn}})
                    </span>
                </div>
            </template>
            <template #search="{attributes, events}">
                    <input
                    class="vs__search"
                    :required="!value"
                    v-bind="attributes"
                    v-on="events"
                    />
            </template>
        </v-select>

        </template>
      </form-group>
</template>

<script>
import _ from "lodash"
import axios from "axios"

export default {
    created() {
        this.$store.dispatch("loadEmployees")
    },

    props: {
        value: [Object],
        label: [String],
        tip: [String],
        v: [Object],
        slug: [String],
        showPcn: [Boolean],
        required: [Boolean],
        disabled: [Boolean],
        messages: [Object],
    },

    data() {
        return {
            defaultSelection: {
                name: '',
                    email: '',
                    userId: '',
                    phone: '',
                    employeeId: '',
            }
        } 
    },
    
    computed: {
        id() {
            return _.uniqueId('employeeSelector')
        },
        options() {
            return this.$store.state.employees
        }
    },

    methods: {
        onSelected(item) {
            this.$emit('input', item)
        },
        myFilterBy(option, label, search) {
          if(search.length < 2) {
            return true
          }
          return (label || '').toLowerCase().indexOf(search.toLowerCase()) > -1
        },

  },
}
</script>

<style>
.vs__dropdown-menu {
    max-height:200px;
}
.vs__spinner {
    font-size: 1em;
}
</style>